document.addEventListener("DOMContentLoaded", function () {
  const announcements = document.querySelectorAll(".announcement-bar");
  let currentIndex = 0;
  const intervalTime = 3000;

  function showAnnouncement(index) {
    announcements.forEach((bar, i) => {
      if (i === index) {
        bar.classList.add("active");
      } else {
        bar.classList.remove("active");
      }
    });
  }

  function rotateAnnouncements() {
    currentIndex = (currentIndex + 1) % announcements.length;
    showAnnouncement(currentIndex);
  }

  // Show first announcement initially
  showAnnouncement(currentIndex);

  // Start rotating
  setInterval(rotateAnnouncements, intervalTime);

  // Handle default address selection
  const defaultAddressRadios = document.querySelectorAll('.address-card__radio');

  defaultAddressRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        const addressId = this.getAttribute('data-address-id');
        setDefaultAddress(addressId);
      }
    });
  });

  function setDefaultAddress(addressId) {
    // Create form data
    const formData = new FormData();
    formData.append('_method', 'put');
    formData.append('address[default]', 'true');

    // Send request to set default address
    fetch(`/account/addresses/${addressId}`, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (response.ok) {
        // Reload the page to reflect the changes
        window.location.reload();
      } else {
        console.error('Failed to set default address');
        alert('Failed to set default address. Please try again.');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('An error occurred. Please try again.');
    });
  }

  // Tab switching functionality
  const tabs = document.querySelectorAll('.delivery-tab');
  const deliveryPanel = document.getElementById('delivery-panel');
  const paymentPanel = document.getElementById('payment-panel');

  if (tabs.length > 0 && deliveryPanel && paymentPanel) {
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetPanel = this.getAttribute('aria-controls');

        // Remove active class from all tabs
        tabs.forEach(t => {
          t.classList.remove('delivery-tab--active');
          t.setAttribute('aria-selected', 'false');
        });

        // Add active class to clicked tab
        this.classList.add('delivery-tab--active');
        this.setAttribute('aria-selected', 'true');

        // Show/hide panels based on selected tab
        if (targetPanel === 'delivery-panel') {
          deliveryPanel.style.display = 'flex';
          paymentPanel.style.display = 'none';
        } else if (targetPanel === 'payment-panel') {
          deliveryPanel.style.display = 'none';
          paymentPanel.style.display = 'flex';
        }
      });
    });
  }
});

